/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BeeGFSNode,
    BeeGFSNodeFromJSON,
    BeeGFSNodeFromJSONTyped,
    BeeGFSNodeToJSON,
    BeeGFSTarget,
    BeeGFSTargetFromJSON,
    BeeGFSTargetFromJSONTyped,
    BeeGFSTargetToJSON,
} from './';

/**
 * 
 * @export
 * @interface VolumeBeeGFSStatus
 */
export interface VolumeBeeGFSStatus {
    /**
     * 
     * @type {Array<BeeGFSNode>}
     * @memberof VolumeBeeGFSStatus
     */
    nodes: Array<BeeGFSNode>;
    /**
     * 
     * @type {Array<BeeGFSTarget>}
     * @memberof VolumeBeeGFSStatus
     */
    targets: Array<BeeGFSTarget>;
}

export function VolumeBeeGFSStatusFromJSON(json: any): VolumeBeeGFSStatus {
    return VolumeBeeGFSStatusFromJSONTyped(json, false);
}

export function VolumeBeeGFSStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeBeeGFSStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nodes': ((json['nodes'] as Array<any>).map(BeeGFSNodeFromJSON)),
        'targets': ((json['targets'] as Array<any>).map(BeeGFSTargetFromJSON)),
    };
}

export function VolumeBeeGFSStatusToJSON(value?: VolumeBeeGFSStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nodes': ((value.nodes as Array<any>).map(BeeGFSNodeToJSON)),
        'targets': ((value.targets as Array<any>).map(BeeGFSTargetToJSON)),
    };
}


